import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { setPostLoginRedirect } from '../utils/postLoginRedirect'
import FullScreenLoader from './FullScreenLoader'

/**
 * Gate for protected routes. While the session is being verified we show a
 * full-screen loader (no protected UI flashes); with no session we redirect to
 * /login, remembering where the user was headed so login can return them there.
 */
const ProtectedRoute: React.FC = () => {
  const { status } = useAuth()
  const location = useLocation()

  if (status === 'checking') {
    return <FullScreenLoader />
  }

  if (status === 'unauthenticated') {
    // Skip when already heading to /login to avoid storing a useless entry.
    if (location.pathname !== '/login') {
      setPostLoginRedirect(location.pathname + location.search)
    }
    return <Navigate to="/login" replace />
  }

  return <Outlet />
}

export default ProtectedRoute
